import { format, parse, subMinutes } from 'date-fns';

export const subtractOneMinute = (timeStr: string) => {
  const parsedTime = parse(timeStr, 'hh:mm a', new Date());

  const newTime = subMinutes(parsedTime, 1);

  return format(newTime, 'hh:mm a');
};
